import { IMenu } from '../../../redux/initState/InterfacesState';
import { EnumUrlsPages } from '../../../services/Enum';

export const DeliveryList: [IMenu[], IMenu[]] = [
  [
    { text: 'Услуги', link: '' },
    { text: 'Доставка Next Day', link: `${EnumUrlsPages.deliveryNextDay}`, hash: true },
    { text: 'Доставка Same Day', link: EnumUrlsPages.deliverySameDay },
    { text: 'Доставка на маркетплейсы', link: `${EnumUrlsPages.deliveryMarketplace}` },
    { text: 'Доставка КГТ', link: '/dostavka-krupnogabaritnykh-tovarov/'},
    { text: 'Доставка в ПВЗ', link: `${EnumUrlsPages.deliveryPVZ}` },
    { text: 'Ship from store', link: `${EnumUrlsPages.deliveryShipFromStore}` },
    // { text: 'Доставка Почтой России', link: `${EnumUrlsPages.delivery}#ru`, hash: true },
    { text: 'Доставка для интернет-магазинов', link: EnumUrlsPages.deliveryInternet },
    { text: 'B2B', link: EnumUrlsPages.deliveryB2B },
    { text: 'Доставка для юридических лиц', link: `${EnumUrlsPages.deliveryForLegal}` },
  ],
  [
    { text: 'География доставки', link: '' },
    { text: 'Доставка по Москве и МО', link: EnumUrlsPages.deliveryMsk },
    { text: 'Доставка по Санкт-Петербургу и ЛО', link: EnumUrlsPages.deliverySpb },
    { text: 'Доставка из Москвы в СПб и ЛО', link: EnumUrlsPages.deliveryMskToSpb },
    { text: 'Доставка в Центральный ФО', link: EnumUrlsPages.deliveryCFO },
    { text: 'Доставка в Северо-Западный ФО', link: EnumUrlsPages.deliverySZFO },
    { text: 'Доставка в Приволжский ФО', link: EnumUrlsPages.deliveryPFO },
    { text: 'Доставка в Южный ФО', link: EnumUrlsPages.deliveryUFO },
    { text: 'Доставка в Уральский ФО', link: EnumUrlsPages.deliveryUrFO },
    { text: 'Доставка в Сибирский ФО', link: EnumUrlsPages.deliverySbFO },
    { text: 'Доставка в Северо-Кавказский ФО', link: EnumUrlsPages.deliverySK },
  ],
];
